module.exports = __webpack_public_path__ + "img/md.5f734d92.svg";